// extracted by mini-css-extract-plugin
export var activeImage = "SectionLayout-module--activeImage--c7b86";
export var bacgroundImage = "SectionLayout-module--bacgroundImage--163ac";
export var bgVideo = "SectionLayout-module--bgVideo--e9ad9";
export var contentContainer = "SectionLayout-module--contentContainer--8050c";
export var desktopVideo = "SectionLayout-module--desktopVideo--09fa8";
export var imageArr = "SectionLayout-module--imageArr--0b0e3";
export var mobileVideo = "SectionLayout-module--mobileVideo--fcba6";
export var overlay = "SectionLayout-module--overlay--07e53";
export var sectionContainer = "SectionLayout-module--sectionContainer--3094b";
export var videoContainer = "SectionLayout-module--videoContainer--13587";